import { Component, Input } from '@angular/core';
import { SnackbarService } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { SnackbarType } from '../../../shared/services/snackbar.service';

@Component({
    selector: 'app-watch-list-button',
    template: `
    @if (!watching) {
      <mat-icon
        class="tw-color-[var(--sed-dynamic-black-color)]"
      [ngClass]="{
        'icon-watch': !large,
        'icon-watch-large': large,
        'star-border-black': !watching
      }"
        [title]="'Add to watch list' | translation: translationRequest"
        >star_border</mat-icon
        >
      }
      @if (watching) {
        <mat-icon
          class="-tw-text-yellow-400 app-color-accent"
      [ngClass]="{
        'icon-watch': !large,
        'icon-watch-large': large,
        'star-filled-green': watching
      }"
          [title]="'Remove from watch list' | translation: translationRequest"
          >star</mat-icon
          >
        }
    `,
    styles: [
        `
      .icon-watch,
      .icon-watch-large {
        cursor: pointer;
        position: relative;
      }

      .icon-watch {
        font-size: 20px;
        width: 20px;
        height: 20px;
      }

      .icon-watch-large {
        font-size: 32px;
        width: 32px;
        height: 32px;
      }

      .star-border-black {
        color: var(--sed-dynamic-black-color);
      }

      .star-filled-green {
        color: var(--sed-sedgwick-green-color);
        -webkit-text-stroke: 1px var(--sed-dynamic-black-color);
        text-stroke: 1px var(--sed-dynamic-black-color);
      }
    `,
    ],
    standalone: false
})
export class WatchListButtonComponent {
  @Input()
  large = false;

  @Input()
  watching: boolean;

  @Input()
  translationRequest: TranslationRequest;

  constructor(private snackbar: SnackbarService) {}

  watch() {
    this.watching = true;
    this.snackbar.show('Claim added to watch list', SnackbarType.Info);
  }

  removeWatch() {
    this.watching = false;
    this.snackbar.show('Claim removed from watch list', SnackbarType.Info);
  }
}
